import api from '@/lib/api'
import { UserStatus } from '@/lib/enums'
import utils from '@/lib/utils'
// import { pinyin } from 'pinyin-pro'

// async function addOrganization ({ dicText, type, parentId, sort }) {
//   const searchResult = await api.bis.post('/dic/org/search', {
//     filters: {
//       name: dicText,
//       type: type,
//       parentId: parentId
//     },
//     page: {
//       pageNum: 1,
//       pageSize: 99999999,
//       orderBy: [
//         { field: 'create_time', order: 'asc' }
//       ]
//     }
//   })
//   if (!searchResult.success) {
//     return searchResult
//   }
//   if (searchResult.data?.data?.length) {
//     // 已存在同名, 忽略之
//     console.log('已存在同名组织, 忽略之', dicText, type, parentId)
//     return searchResult
//   } else {
//     // 新增
//     const addResult = await api.bis.post('/dic/org/', {
//       name: dicText,
//       namePy: pinyin(dicText, { pattern: 'first', type: 'array' }).join(''),
//       type: type,
//       parentId: parentId ?? 0,
//       sort: sort ?? 0,
//       remarks: null,
//       // category: 1,
//       hisDeptNo: null
//     })
//     return addResult
//   }
// }

const modelMetas = {
  user: {
    load: 'loadUsers',
    loaded: 'usersLoaded',
    models: 'users',
    options: 'usersOptions',
    setState: 'setUsers',
    request: () => api.bis.get('/userEntity/').then(result => result.notifyIfFail()), // TODO: nocache, get改为post
    getData: result => result.data,
    icon: 'person',
    label: '用户'
  }
};

(function () {
  for (const key in modelMetas) {
    if (Object.hasOwnProperty.call(modelMetas, key)) {
      const meta = modelMetas[key]
      if (meta.extends) {
        const extendsMeta = modelMetas[meta.extends]
        for (const metaField in extendsMeta) {
          if (!meta[metaField]) meta[metaField] = extendsMeta[metaField]
        }
      }
    }
  }
})()
async function loadModelsCore (modelName, context, { force = false } = {}) {
  const modelMeta = modelMetas[modelName]
  if (!modelMeta) {
    console.error('未知的字典模型名称:' + modelName)
    return false
  }
  if (force || !context.getters[modelMeta.loaded]) {
    const result = await (modelMeta.request ? modelMeta.request() : api.bis.post(modelMeta.url, {}).then(result => result.notifyIfFail()))
    if (result.success) {
      context.commit(modelMeta.setState, modelMeta.getData ? modelMeta.getData(result) : result.data.data)
    }
    return result.success
  } else {
    return true
  }
}

function createUserOption (model) {
  return Object.freeze({ value: model.id, text: model.name, label: model.name, textPy: model.workNo + '|' + model.username, model: model })
}

export default function () {
  return {
    namespaced: true,
    state: {
      users: null,
      usersMapById: null
    },
    getters: {
      modelsOptions: (state, getters) => modelName => getters[modelMetas[modelName].options],
      modelsOptionsByParentId: (state, getters) => (modelName, parentId) => getters[modelMetas[modelName].optionsByParentId](parentId),
      modelsLoaded: (state, getters) => modelName => getters[modelMetas[modelName].loaded],
      allModelsLoaded: (state, getters) => {
        for (const modelName in modelMetas) {
          if (Object.hasOwnProperty.call(modelMetas, modelName)) {
            if (!getters[modelMetas[modelName].loaded]) return false
          }
        }
        return true
      },
      modelIcon: state => modelName => modelMetas[modelName].icon,
      modelLabel: state => modelName => modelMetas[modelName].label,
      modelRequireParent: state => modelName => Boolean(modelMetas[modelName].optionsByParentId),
      modelAddHandler: state => modelName => modelMetas[modelName].addHandler,

      // user
      usersOptions: state => state.users?.filter(user => (user.status ?? UserStatus.Enabled) === UserStatus.Enabled).map(createUserOption),
      usersLoaded: state => !!state.users,
      userById: state => id => state.usersMapById?.get(id),
      userNameById: state => id => state.usersMapById?.get(id)?.name
    },
    mutations: {
      setUsers (state, newUsers) {
        state.users = utils.deepFreeze(newUsers)
        state.usersMapById = new Map(newUsers?.map(item => [item.id, item]))
      }
    },
    actions: {
      async loadUsers (context, payload) {
        return await loadModelsCore('user', context, payload)
      },
      async loadModels (context, payload) {
        if (payload?.modelName) {
          return await context.dispatch(modelMetas[payload.modelName].load, payload)
        } else {
          const loadMethodNames = Object.create(null)
          for (const key in modelMetas) {
            if (Object.hasOwnProperty.call(modelMetas, key)) {
              const modelMeta = modelMetas[key]
              loadMethodNames[modelMeta.load] = true
            }
          }
          let success = true
          const promises = []
          for (const loadMethodName in loadMethodNames) {
            promises.push(context.dispatch(loadMethodName, payload).then(result => {
              success &= result
            }))
          }
          await Promise.all(promises)
          return success
        }
      }
    }
  }
}
